import { SvgIcons } from '@ngneat/svg-icon';

import { ConnectorTypeStoreModelEnum, EvseStatusStoreModelEnum } from '@domain/single-site/single-site.enums';

export const EVSE_STATUS_PROPERTIES_MAP: Record<
  EvseStatusStoreModelEnum,
  {
    iconName16: Record<ConnectorTypeStoreModelEnum, SvgIcons>;
    iconName40: Record<ConnectorTypeStoreModelEnum, SvgIcons>;
    bgColorClass: string;
    fillColorClass: string;
    borderColorClass: string;
    textColorClass: string;
    dropShadowClass: string;
  }
> = {
  [EvseStatusStoreModelEnum.Charging]: {
    iconName16: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'charging-16',
      [ConnectorTypeStoreModelEnum.Type2]: 'charging-16',
      [ConnectorTypeStoreModelEnum.Chademo]: 'charging-16',
      [ConnectorTypeStoreModelEnum.Nacs]: 'charging-16',
      [ConnectorTypeStoreModelEnum.Mcs]: 'charging-16',
    },
    iconName40: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'charging-40',
      [ConnectorTypeStoreModelEnum.Type2]: 'charging-40',
      [ConnectorTypeStoreModelEnum.Chademo]: 'charging-40',
      [ConnectorTypeStoreModelEnum.Nacs]: 'charging-40',
      [ConnectorTypeStoreModelEnum.Mcs]: 'charging-40',
    },
    bgColorClass: 'bg-chargingstatus-charging-100',
    fillColorClass: 'fill-chargingstatus-charging-100',
    borderColorClass: 'border-chargingstatus-charging-100',
    textColorClass: 'text-chargingstatus-charging-100',
    dropShadowClass: 'drop-shadow-chargingstatus-charging-100-shadow-30',
  },
  [EvseStatusStoreModelEnum.Queued]: {
    iconName16: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'queued-16',
      [ConnectorTypeStoreModelEnum.Type2]: 'queued-16',
      [ConnectorTypeStoreModelEnum.Chademo]: 'queued-16',
      [ConnectorTypeStoreModelEnum.Nacs]: 'queued-16',
      [ConnectorTypeStoreModelEnum.Mcs]: 'queued-16',
    },
    iconName40: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'queued-40',
      [ConnectorTypeStoreModelEnum.Type2]: 'queued-40',
      [ConnectorTypeStoreModelEnum.Chademo]: 'queued-40',
      [ConnectorTypeStoreModelEnum.Nacs]: 'queued-40',
      [ConnectorTypeStoreModelEnum.Mcs]: 'queued-40',
    },
    bgColorClass: 'bg-chargingstatus-queued-100',
    fillColorClass: 'fill-chargingstatus-queued-100',
    borderColorClass: 'border-chargingstatus-queued-100',
    textColorClass: 'text-chargingstatus-queued-100',
    dropShadowClass: 'drop-shadow-chargingstatus-queued-100-shadow-30',
  },
  [EvseStatusStoreModelEnum.Available]: {
    iconName16: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'charger-16',
      [ConnectorTypeStoreModelEnum.Type2]: 'connector-type-2-16',
      [ConnectorTypeStoreModelEnum.Chademo]: 'connector-chademo-16',
      [ConnectorTypeStoreModelEnum.Nacs]: 'connector-nacs-16',
      [ConnectorTypeStoreModelEnum.Mcs]: 'connector-mcs-16',
    },
    iconName40: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'charger-40',
      [ConnectorTypeStoreModelEnum.Type2]: 'connector-type-2-40',
      [ConnectorTypeStoreModelEnum.Chademo]: 'connector-chademo-40',
      [ConnectorTypeStoreModelEnum.Nacs]: 'connector-nacs-40',
      [ConnectorTypeStoreModelEnum.Mcs]: 'connector-mcs-40',
    },
    bgColorClass: 'bg-status-success',
    fillColorClass: 'fill-status-success',
    borderColorClass: 'border-status-success',
    textColorClass: 'text-status-success',
    dropShadowClass: 'drop-shadow-status-success-shadow-30',
  },
  [EvseStatusStoreModelEnum.Faulted]: {
    iconName16: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'faulted-16',
      [ConnectorTypeStoreModelEnum.Type2]: 'faulted-16',
      [ConnectorTypeStoreModelEnum.Chademo]: 'faulted-16',
      [ConnectorTypeStoreModelEnum.Nacs]: 'faulted-16',
      [ConnectorTypeStoreModelEnum.Mcs]: 'faulted-16',
    },
    iconName40: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'faulted-40',
      [ConnectorTypeStoreModelEnum.Type2]: 'faulted-40',
      [ConnectorTypeStoreModelEnum.Chademo]: 'faulted-40',
      [ConnectorTypeStoreModelEnum.Nacs]: 'faulted-40',
      [ConnectorTypeStoreModelEnum.Mcs]: 'faulted-40',
    },
    bgColorClass: 'bg-chargingstatus-faulted-100',
    fillColorClass: 'fill-chargingstatus-faulted-100',
    borderColorClass: 'border-chargingstatus-faulted-100',
    textColorClass: 'text-chargingstatus-faulted-100',
    dropShadowClass: 'drop-shadow-chargingstatus-faulted-100-shadow-30',
  },
  [EvseStatusStoreModelEnum.Maintenance]: {
    iconName16: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'wrench-16',
      [ConnectorTypeStoreModelEnum.Type2]: 'wrench-16',
      [ConnectorTypeStoreModelEnum.Chademo]: 'wrench-16',
      [ConnectorTypeStoreModelEnum.Nacs]: 'wrench-16',
      [ConnectorTypeStoreModelEnum.Mcs]: 'wrench-16',
    },
    iconName40: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'wrench-40',
      [ConnectorTypeStoreModelEnum.Type2]: 'wrench-40',
      [ConnectorTypeStoreModelEnum.Chademo]: 'wrench-40',
      [ConnectorTypeStoreModelEnum.Nacs]: 'wrench-40',
      [ConnectorTypeStoreModelEnum.Mcs]: 'wrench-40',
    },
    bgColorClass: 'bg-status-warning',
    fillColorClass: 'fill-status-warning',
    borderColorClass: 'border-status-warning',
    textColorClass: 'text-status-warning',
    dropShadowClass: 'drop-shadow-status-warning-shadow-30',
  },
  [EvseStatusStoreModelEnum.Unknown]: {
    iconName16: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'unknown-16',
      [ConnectorTypeStoreModelEnum.Type2]: 'unknown-16',
      [ConnectorTypeStoreModelEnum.Chademo]: 'unknown-16',
      [ConnectorTypeStoreModelEnum.Nacs]: 'unknown-16',
      [ConnectorTypeStoreModelEnum.Mcs]: 'unknown-16',
    },
    iconName40: {
      [ConnectorTypeStoreModelEnum.Ccs2]: 'unknown-40',
      [ConnectorTypeStoreModelEnum.Type2]: 'unknown-40',
      [ConnectorTypeStoreModelEnum.Chademo]: 'unknown-40',
      [ConnectorTypeStoreModelEnum.Nacs]: 'unknown-40',
      [ConnectorTypeStoreModelEnum.Mcs]: 'unknown-40',
    },
    bgColorClass: 'bg-foreground-primary-100',
    fillColorClass: 'fill-foreground-primary-80',
    borderColorClass: 'border-foreground-primary-100',
    textColorClass: 'text-foreground-primary-100',
    dropShadowClass: 'drop-shadow-foreground-primary-100-shadow-30',
  },
};
